import React from "react";
import styled from "@emotion/styled";
import Paper from "@mui/material/Paper";
import { Bar } from "react-chartjs-2";

import ParkkiTheme from "themes/ParkkiTheme";
import Placeholder from "./Placeholder";
import { useGrapContext } from "services/graphs/GraphProvider";

const Container = styled(Paper)`
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: "Source Sans Pro", sans-serif;
  height: ${(props: { height?: string }) => props.height || "200px"};
  padding-right: ${ParkkiTheme.spacings.base};
  padding-left: ${ParkkiTheme.spacings.base};
  padding-top: ${ParkkiTheme.spacings.base};
  padding-bottom: ${ParkkiTheme.spacings.tiny};
`;

type Props = {
  stats: { toggle: boolean };
  graphOptions: object;
  initialized: boolean;
  height?: string;
};

function StatsChart({
  stats,
  graphOptions,
  height,
  initialized,
}: Props): JSX.Element {
  const { setRef }: any = useGrapContext();

  if (!stats?.toggle) return <></>;

  if (!initialized) {
    return <Placeholder delay={500} ready={false} height={height} />;
  }

  return (
    <Container height={height}>
      <Bar data={stats} options={graphOptions} ref={(el) => setRef(el)} />
    </Container>
  );
}

export default StatsChart;
